import React from 'react';
import PropTypes from 'prop-types';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import I18n from 'i18n-react';
import { Button } from 'react-bootstrap';
import LoginCookie from '../loginCookie/LoginCookie';
import TrackME from '../modules/trackMe';
import FeatureService from '../../services/feature/FeatureService';
import Features from '../../const/Features';
import ErrorsCodes from '../../const/ErrorsCodes';

import './CheckoutContainer.css';
import BookingService from '../../services/booking/BookingService';
import ErrorHandler from '../../errorHandler';
import * as CryptoAdyenUC from '../../usecases/cryptoAdyen/CryptoAdyenUC';
import { isFromCallcenter } from '../../services/queryService/QueryService';

import EventEmitter from '../modules/event-emitter/EventEmitter';
import Listener from '../../const/Listener';
import InfoReloadModal from '../common/bestPriceModal/InfoReloadModal';
import LocalStorage from '../../const/LocalStorage';
import $ from 'jquery';

const propTypes = {
  quotationJourney: PropTypes.shape({
    passengers: PropTypes.shape({
      adultNumber: PropTypes.number.isRequired,
      childNumber: PropTypes.number,
      infantNumber: PropTypes.number
    }),
    departureFlight: PropTypes.shape({
      value: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired,
      childValue: PropTypes.number,
      infantValue: PropTypes.number,
      flight: PropTypes.shape({
        id: PropTypes.number.isRequired,
        originAirport: PropTypes.string.isRequired,
        originAirportName: PropTypes.string.isRequired,
        finalDestination: PropTypes.string.isRequired,
        finalDestinationName: PropTypes.string.isRequired,
        departureDate: PropTypes.string.isRequired,
        departureTime: PropTypes.string.isRequired,
        finalArrivalDate: PropTypes.string.isRequired,
        finalArrivalTime: PropTypes.string.isRequired,
        dateVariation: PropTypes.number.isRequired,
        prices: PropTypes.arrayOf(
          PropTypes.shape({
            category: PropTypes.string,
            passenger: PropTypes.string,
            value: PropTypes.number,
            currency: PropTypes.string
          })
        ).isRequired,
        recommendations: PropTypes.arrayOf(
          PropTypes.shape({
            departureCategory: PropTypes.string.isRequired,
            returnFlights: PropTypes.arrayOf(
              PropTypes.shape({
                id: PropTypes.number.isRequired,
                category: PropTypes.arrayOf(
                  PropTypes.shape({
                    returnCategory: PropTypes.string.isRequired,
                    prices: PropTypes.arrayOf(
                      PropTypes.shape({
                        category: PropTypes.string,
                        passenger: PropTypes.string,
                        value: PropTypes.number,
                        currency: PropTypes.string
                      })
                    ).isRequired,
                    fee: PropTypes.shape({
                      total: PropTypes.shape({
                        value: PropTypes.number.isRequired,
                        currency: PropTypes.string.isRequired
                      })
                    }),
                    fare: PropTypes.object
                  }).isRequired
                )
              })
            ),
            fee: PropTypes.shape({
              total: PropTypes.shape({
                value: PropTypes.number.isRequired,
                currency: PropTypes.string.isRequired
              })
            }),
            fare: PropTypes.object
          })
        ),
        flightGroup: PropTypes.array.isRequired
      }).isRequired
    }).isRequired,
    returnFlight: PropTypes.shape({
      value: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired,
      childValue: PropTypes.number,
      infantValue: PropTypes.number,
      flight: PropTypes.shape({
        id: PropTypes.number.isRequired,
        originAirport: PropTypes.string.isRequired,
        originAirportName: PropTypes.string.isRequired,
        finalDestination: PropTypes.string.isRequired,
        finalDestinationName: PropTypes.string.isRequired,
        departureDate: PropTypes.string.isRequired,
        departureTime: PropTypes.string.isRequired,
        finalArrivalDate: PropTypes.string.isRequired,
        finalArrivalTime: PropTypes.string.isRequired,
        dateVariation: PropTypes.number.isRequired,
        prices: PropTypes.arrayOf(
          PropTypes.shape({
            category: PropTypes.string,
            passenger: PropTypes.string,
            value: PropTypes.number,
            currency: PropTypes.string
          })
        ).isRequired,
        flightGroup: PropTypes.array.isRequired,
        fee: PropTypes.shape({
          total: PropTypes.shape({
            value: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired
          })
        }),
        fare: PropTypes.object
      }).isRequired
    })
  }).isRequired,
  flightsFilter: PropTypes.shape({
    flightOrigin: PropTypes.shape({
      searchCode: PropTypes.string.isRequired
    }).isRequired,
    flightDestiny: PropTypes.shape({
      searchCode: PropTypes.string
    })
  }).isRequired,
  passengerInfo: PropTypes.arrayOf(
    PropTypes.shape({
      passengerType: PropTypes.string.isRequired,
      travellingWithValues: PropTypes.array,
      name: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      gender: PropTypes.string.isRequired,
      age: PropTypes.string.isRequired,
      travellingWith: PropTypes.string
    })
  ).isRequired,
  checkoutInfo: PropTypes.object,
  btnDisabled: PropTypes.bool,
  location: PropTypes.object,
  proceedTo: PropTypes.func.isRequired,
  isFormValid: PropTypes.func.isRequired,
  principalContact: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  btnDisabled: false,
  location: {
    search: null
  }
};

class CheckoutContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      messageInfo: null,
      isRedirect: false,
      pathname: '/',
      renderCookie: false,
      renderCookieOnLoad: true,
      modalInactity: false,
      isCallcenterEnabled: props.isCallcenterEnabled || false,
      featureAdyenEncryptedEnabled: false,
      cardEncrypted: null,
      openModalError288:false
    };

    this.showModal = this.showModal.bind(this);
  }

  componentWillMount() {
    const script = document.createElement('script');

    script.src =
      global.env.ADYEN_APP_DOMAIN || 'https://test.adyen.com/hpp/cse/js/7814581483050358.shtml';
    script.async = true;

    document.body.appendChild(script);
    this.featureAdyenCardEncrypted();

    this.setState({
      modalInactivityListener: EventEmitter.createListener(
        Listener.SHOW_MODAL_INACTIVITY,
        this.showModalInactivity
      )
    });
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.modalInactivityListener);
  }

  featureAdyenCardEncrypted() {
    FeatureService.isFeatureEnabled(Features.ADYEN_CARD_ENCRYPTED)
      .then(isEnabled => {
        this.setState({
          featureAdyenEncryptedEnabled: isEnabled
        });
      })
      .catch(() => {});
  }

  showModalInactivity = errorType => {
    if (ErrorsCodes.CALLCENTER_ACCESS_DENIED_ERROR === errorType[0]) {
      this.setState({
        pathname: '/?callcenter=false'
      });
      this.showModal(I18n.translate('home.msg.error'), true);
    } else {
      this.setState({ modalInactity: true });
      this.showModal(I18n.translate('home.msg.session.callCenterExpired'), false);
    }
  };

  toggleLoadingModal() {
    var I18n = require('i18n-react').default;
    $('#loader-message').text(I18n.translate('loading'));
    window.showLoadingScreen();
  }

  bookingService(data) {
    const checkoutEncrypted = {
      cardType: this.props.checkoutInfo.cardType,
      cardEncrypted: this.state.cardEncrypted,
      installments: this.props.checkoutInfo.installment ? this.props.checkoutInfo.installment : null,
    };
    BookingService.saveBooking(
      {
        principalContactInfo: data,
        isPrincipalContact: this.props.principalContact,
        passengerInfo: this.props.passengerInfo,
        checkoutInfo: this.state.cardEncrypted ? checkoutEncrypted : this.props.checkoutInfo,
        flightsFilter: this.props.flightsFilter,
        quotationJourney: this.props.quotationJourney
      },
      this.state.featureAdyenEncryptedEnabled,
      this.callCenterMode()
    )
      .then(({ status, body }) => {
        this.toggleLoadingModal();
        if (body && body.pnrNumber && status === 201) {
          this.props.proceedTo('/resume', body);
        } else if(body.reason  && body.reason  ===  I18n.translate('components.checkoutInfo.errorMsg.erro288')){
          {this.setState({ openModalError288: true })};          
        } else {
          this.showBookingErrorMessage(...ErrorHandler.handler(status, body, this.callCenterMode()));
        }
      })
      .catch(() => {});
  }

  saveBooking(data) {
    if (this.props.isFormValid()) {
      TrackME.run(data.username, 'PAGAMENTO_CARTAO');
      if (this.state.featureAdyenEncryptedEnabled) {
        CryptoAdyenUC.execute(this.props.checkoutInfo)
          .then(adyenResponse => {
            this.setState({ cardEncrypted: adyenResponse.cardEncrypted });
            this.bookingService(data);
          })
          .catch(() => this.showBookingErrorMessage(false));
      } else {
        this.bookingService(data);
      }
    } else {
      this.setState({
        renderCookie: false
      });
    }
  }

  showBookingErrorMessage(isRedirect, errorMessage) {
    this.setState({
      renderCookie: false
    });
    const message = errorMessage ? errorMessage : I18n.translate('home.msg.error');
    this.showModal(message, isRedirect);
  }

  showModal(message, isRedirect) {
    this.setState({
      openModal: true,
      messageInfo: message,
      isRedirectModal: isRedirect
    });
  }

  closeModal() {
    if (this.callCenterMode() && this.state.modalInactity) {
      document.location.assign(global.env.CALLCENTER_LOGOUT_URL);
    } else {
      this.setState({
        openModal: false,
        messageInfo: null
      });

      if (this.state.isRedirectModal) {
        this.props.proceedTo(this.state.pathname);
      }
    }
  }

  cookieCallback = data => {
    if (this.state.renderCookieOnLoad) {
      this.validateCookieOnLoad(data);
    } else {
      this.validateCookie(data);
    }
  };

  validateCookieOnLoad(data) {
    this.setState({
      renderCookieOnLoad: false
    });

    if (!data) {
      this.showModal(I18n.translate('home.msg.session.expired'), true);
    }
  }

  validateCookie(data) {
    if (data) {
      this.saveBooking(data);
    } else {
      this.showModal(I18n.translate('home.msg.session.expired'), true);
    }
  }

  submitCallcenterMode() {
    const dataStorage = localStorage.getItem(LocalStorage.CUSTOMER_DATA_CALLCENTER);
    if (dataStorage) {
      const data = JSON.parse(dataStorage);
      this.saveBooking(data);
    } else {
      this.showModal(I18n.translate('home.msg.session.expired'), true);
    }
  }

  renderContainerActions() {
    if ((this.state.renderCookieOnLoad || this.state.renderCookie) && !this.callCenterMode()) {
      return (
        <LoginCookie callbackCookie={this.cookieCallback} callcenterMode={this.callCenterMode()} />
      );
    }
  }

  renderModalError288() {
    return (
      <InfoReloadModal
        id="modalerror2008"
        message={I18n.translate('components.checkoutInfo.modalInf.messageError288')}        
        showModal={this.state.openModalError288}           
        firstOption={() => { window.history.go(-2) }} 
        iconTimer={false}       
        ref={c => {
          this.modalerror2008 = c;
        }}
      />
    );
  }

  render() {
    return (
      <div className="checkoutContainer">
        <div>
          {this.renderContainerActions()}
          <Button
            id="btnInitBooking"
            bsClass="btn btn-default CheckoutContainer__nextButton"
            onClick={() => {
              this.toggleLoadingModal();
              !this.callCenterMode() ?
                 this.setState({  renderCookie: true })
                 :
                 this.submitCallcenterMode()  
            }}
            disabled={this.props.btnDisabled}  
          >
            {I18n.translate('checkout.emitTicket')}
          </Button>
          <InfoModal
            id="modalCheckoutInfo"
            message={this.state.messageInfo}
            showModal={this.state.openModal}
            close={() => this.closeModal()}
            ref={c => {
              this.modalCheckoutInfo = c;
            }}
          />
          {this.renderModalError288()}
        </div>
      </div>
    );
  }

  callCenterMode() {
    return this.state.isCallcenterEnabled && isFromCallcenter();
  }
}

CheckoutContainer.propTypes = propTypes;
CheckoutContainer.defaultProps = defaultProps;

export default CheckoutContainer;



// WEBPACK FOOTER //
// ./src/components/checkoutContainer/CheckoutContainer.jsx